import React, { useEffect, useContext, useState } from "react";
import { connect } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { DatosCompradorContext } from "../context/Context";
import { Creators } from "../store/ducks/users";
import { filteredMenuItems } from "./MenuItems";

const ProtectedRouter = ({ children, menu, /* token,*/ logout }) => {
  const { resetDatos } = useContext(DatosCompradorContext);
  const [loginCookie] = React.useState(Cookies.get("loginCookie"));
  const [hasAccess, setHasAccess] = useState(true);
  const [pathModule, setPathModule] = useState("");
  const path = useLocation();

  useEffect(() => {
    let pathSinHash = path.pathname; // /home
    setPathModule(pathSinHash);
    //console.log(pathSinHash, "pathc");
    if (pathSinHash !== "/Pdf") {
      Cookies.remove("FOLIO");
      Cookies.remove("TERMINOS");
      Cookies.remove("FINALIZAR1");
    }
  }, [path]);

  //console.log("PATH", path);
  //console.log("Login Cookie", loginCookie);
  //console.log("TOKEN", token);
  //console.log("MODULES", menu.screens);
  //console.log("PATH MODULE", pathModule);
  //console.log("HAS ACCESS", hasAccess);

  const modulesAcces = [];
  const modulesFilter = filteredMenuItems(menu).map((item) => {
    modulesAcces.push(item.route);
    if (item.route === "/pedidoSelect") {
      modulesAcces.push("/pedidoTienda");
    }
  
    if (item.route === "/formato") {
      modulesAcces.push("/Pdf");
    }
    if (item.route === "/buscadorContratos") {
      modulesAcces.push("/pdfViewer2");
    }
       modulesAcces.push("/verPedidoTienda");
           modulesAcces.push("/stockTienda2");
    // if (item.route === "/admin") {
    //   modulesAcces.push("/pedidoTienda");
    // }
  });
  // console.log("ACCESS MODULES", modulesAcces);

  useEffect(() => {
    if (!menu.screens) {
    } else {
      //console.log("modulos 1", modulesAcces);
      let moduleExist = modulesAcces.some((module) =>
        pathModule.includes(module)
      );
      if (!moduleExist) {
        setHasAccess(false);
      } else {
        setHasAccess(true);
      }
    }
  }, [menu.screens, pathModule]);

  if (!loginCookie) {
    if (path.pathname !== "/") {
      //logout();
      localStorage.clear();
      resetDatos();
      return <Navigate to="/" replace />;
    }
    return <>{children}</>;
  }

  if (!hasAccess) {
    return <Navigate to={`/home`} replace />;
  }

  return <>{children}</>;
};

const mapStateToProps = (state) => {
  return {
    menu: state.users.menu,
    //token: state.users.uid,
  };
};

const creators = {
  logout: Creators.logout,
};

export default connect(mapStateToProps, creators)(ProtectedRouter);
